module.exports = __webpack_public_path__ + "img/PLAYER1-min.8dbdc538.png";